
<template>
  <div class="phrase">
    <div
      class="phrase__popup"
      v-if="selectedWord"
      >
        <div v-if="selectedWord.marked">
          Word marked already.
          <button class="btn--small" v-on:click="selectedWord = null">x</button>
        </div>
        <div v-else>
          <div>
            <a
              target="_blank"
              :href="'https://translate.google.com/#view=home&op=translate&sl=th&tl=en&text=' + selectedWord.word.text">
              Translate
            </a>
          </div>
          ({{ selectedWord.successes }})
          Mark word?
          <button
            class="btn--small"
            v-on:click="addMarkedItem(selectedWord)"
            >
            Yes
          </button>
          <button
            class="btn--small"
            v-on:click="selectedWord = null"
            >
            No
          </button>
        </div>
    </div>
    <div
      class="phrase__word no-select"
      v-for="(word, index) in wordParts"
      v-bind:key="index"
      v-on:click="selectWord(word)"
      >
      {{ word.text }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.phrase {
  position: relative;
}

.phrase__word {
  display: inline-block;
  padding: 2px 5px;
  cursor: pointer;
  &:hover {
    background: #ffe70b;
  }
}

.phrase__popup {
  position: absolute;
  padding: 10px;
  background: white;
  border: 1px solid #ccc;
  z-index: 100;
}

.no-select {
  -webkit-touch-callout: none;
    -webkit-user-select: none;
     -khtml-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

</style>

<script>
import * as db from '@/libs/db.js';

import * as api from '@/libs/api.js';

import { Word } from '@/libs/Word.js';

export default {
  props: ["phrase"],
  store: db.store,
  data() {
    return {
      selectedWord: null,
    };
  },
  computed: {
    wordParts() {
      if (!this.phrase) {
        return [];
      }
      return this.phrase.words;
    },
  },
  methods: {
    async selectWord(word) {
      let selectedWord = {};

      if (await api.isWordMarkedAsKnown(word)) {
        selectedWord.marked = true;
        selectedWord.successes = null;
      } else {
        selectedWord.marked = false;
        selectedWord.successes = await word.getWordSuccesses();
      }

      selectedWord.word = word;
      this.selectedWord = selectedWord;
    },
    async addMarkedItem() {
      let word = this.selectedWord.word;
      await this.$store.dispatch('addMarkedWord', word);
      console.log(`Added new marked word: ${word}`);
      this.selectedWord = null;
    },
  },
  mounted() {
  },
}
</script>